import CameraPlayerPage from './CameraPlayerPage';

export default CameraPlayerPage;
